import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { getApplicationById, getCertificationAmount, updateCertificationDetails } from "../../redux/Actions/GetDocsActions";

import { useHistory } from "react-router-dom";
import Alert from "../../utils/Alert";

import { useLocation } from "react-router-dom";
function EditableCertificationName({ trail, applicationId, getApplicationById, applicationById, getCertificationAmount, updateCertificationDetails }) {

  const [isEditing, setIsEditing] = useState(false);
  const [applicationName, setApplicationName] = useState(trail.company.name || "");
  const [applicationCertificationName, setApplicationCertificationName] = useState("");
  const [applicationCertificationVersion, setApplicationCertificationVersion] = useState("");
  const [applicationType, setApplicationType] = useState(trail.application_type)
  const [applicationStatus, setApplicationStatus] = useState(trail.status)
  const [uniqueType, setUniqueType] = useState(null)
  const [getTrailId, setTrailId] = useState(null)
  const [uniqueAppId, setUniqueAppId] = useState(null)
  const [loading, setLoading] = useState(false);
  const [isEditExceed, setIsEditExceed] = useState(true);
  const [editTriggered, setEditTriggered] = useState(false);


  const history = useHistory();
  const location = useLocation();



  const handleCheckboxChange = async (applicationId, type) => {

    setEditTriggered(true);
    setIsEditing(!isEditing);
    setLoading(true);

    await getApplicationById(applicationId, type);

    setTrailId(applicationId)
    setUniqueType(type)

    setUniqueAppId(applicationId)
    setLoading(false);

    if (isEditing) {
      handleUpdatePosDetailChange(applicationId, type)
    }
  };

  const handleUpdatePosDetailChange = async (appId, type) => {
    const payload = {
      name: applicationCertificationName,
      version: applicationCertificationVersion,
      appType: type
    }
    await updateCertificationDetails(payload, appId)

  };




  useEffect(() => {
  
    if (editTriggered && trail.id === getTrailId && trail.application_type === uniqueType && applicationId === uniqueAppId) {
      setApplicationCertificationName(applicationById.name || "")
      setApplicationCertificationVersion(applicationById.version || "")

      if (applicationById.error_code === "PAYMENT_REQUIRED" || applicationById.error_code === "EDIT_TRAIL_NOT_FOUND" ) {

        getCertificationAmount(1, uniqueAppId)

        let newType = uniqueType === "pos_device_certification" ? "device" : "application";
        history.push({
          pathname: "/payment",
          state: {
            id: uniqueAppId,
            type: newType,
            amount_id: 1
          }
        });

        setEditTriggered(false);

      }

      if (applicationById.error_code === "EDIT_LIMIT_EXCEEDED") {
        Alert(true, "danger", "Error Message", applicationById.message)
        setIsEditExceed(false);
      }
    }

  }, [
    applicationById, 
    getTrailId, 
    uniqueType, 
    uniqueAppId, 
    history, 
    isEditing,
    trail.id,
    trail.application_type

  ]);

  useEffect(() => {
    setApplicationType(trail.application_type);

  }, [trail.application_type]);

  if (applicationById.error_code === "PAYMENT_REQUIRED") {
    return null
  }
  const containerStyle = {
    margin: !isEditing || applicationById.error_code === "EDIT_LIMIT_EXCEEDED" ? '0 0 0.7em 0' : '0 0 7em 0',
  };


  return (
    <div className="form-input-container-editable" style={containerStyle}>
      {loading ? (
        <div className="loading-indicator">Loading...</div> // Display loading indicator
      ) : (
        <>
          <h3 className="app-status name-text">

            {isEditing && (applicationById.error_code === "PAYMENT_REQUIRED" || applicationById.error_code === null) && (
              <>
                <label>
                  <input
                    type="text"
                    name="name"
                    value={applicationCertificationName}
                    onChange={(e) => setApplicationCertificationName(e.target.value)}
                    className="form-input"
                  />
                </label>
                <label>

                  <input
                    type="text"
                    name="version"
                    value={applicationCertificationVersion}
                    onChange={(e) => setApplicationCertificationVersion(e.target.value)}
                    className="form-input"
                  /></label>
              </>
            )

            }
          </h3>
   
        <label className="edit-button">
  <input
    type="button"
    onClick={() => handleCheckboxChange(applicationId, trail.application_type)}
    className="edit-checkbox"
    disabled={trail.edit_count >= 3 || loading}
  />
    {trail.edit_count >= 3 ? (
      <span style={{ fontSize: "1.2rem" }}>Edit Count Exceeded</span>
    ) : (
      <span>
        {!isEditing || (applicationById.error_code === "EDIT_LIMIT_EXCEEDED") 
          ? "Edit" 
          : "Update"}
      </span>
    )}

</label>


        </>
      )}
    </div>
  );

}

const mapDispatchToProps = (dispatch) => ({
  getApplicationById: (id, type) => dispatch(getApplicationById(id, type)),
  getCertificationAmount: (type, id) => dispatch(getCertificationAmount(type, id)),
  updateCertificationDetails: (payload, appId) => dispatch(updateCertificationDetails(payload, appId))
});

const mapStateToProps = (state) => {
  return {
    applicationById: state.docs.applicationById,
    gettingAppId: state.docs.gettingAppById,
    errorGettingAppId: state.docs.errorGettingAppId



  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditableCertificationName);
